<template>
  <FlashSalesSticker
    v-if="productResponse"
    class="my-8 w-full sm:mb-16 sm:mt-0 md:w-auto"
    :discount="flashSalesDiscount"
    :has-deals="productResponse.hasDeals"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FlashSalesSticker from '~/scopes/product-core/components/presentationals/FlashSalesSticker/FlashSalesSticker.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: productResponse } = useFetchProduct()

const flashSalesDiscount = computed(
  () =>
    productResponse.value?.promoCodes.find((promoCode) => promoCode.isFlashSale)
      ?.discountValue,
)
</script>
